import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { InputField } from 'app/core/model/common/input-field.model';

@Component({
  selector: 'app-input-calendar',
  templateUrl: './input-calendar.component.html',
  styleUrls: ['./input-calendar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputCalendarComponent {
  valueOfData: any;
  @Input() fieldOption: InputField = new InputField();
  @Input() pk: string = '';
  @Output() fieldChange = new EventEmitter<InputField>(); // Output event

  constructor() {
    this.valueOfData = this.fieldOption.value;
  }

  ngOnInit() {
    this.fieldOption.pk = this.pk
    if (this.fieldOption.value != null)
      this.valueOfData = new Date(this.fieldOption.value);
  }
  ngAfterViewInit() {
  }

  onInputChange() {
    const d = this.valueOfData instanceof Date ? this.valueOfData : new Date(this.valueOfData);
    const formattedDate = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    this.fieldOption.value = formattedDate;

    if (this.fieldOption.value != null) {
      this.fieldOption.valid = true;
    }
    this.fieldChange.emit(this.fieldOption);
  }
}
